module.exports = __webpack_public_path__ + "static/img/title.a56a93d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/haeusle/title.jpg
// module id = 374
// module chunks = 1